import { render, staticRenderFns } from "./GroupResultsPrint.vue?vue&type=template&id=f2ad7c94"
import script from "./GroupResultsPrint.vue?vue&type=script&lang=js"
export * from "./GroupResultsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports